module.exports = __webpack_public_path__ + "static/img/9.05fa3ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/9.jpg
// module id = /NOx
// module chunks = 0